'use strict';

class CodigoContratoController {
  constructor(Modal,$log,Integracion, $state) {
    'ngInject';

    this.Modal = Modal;
    this.$log=$log;
    this.Integracion = Integracion;
    this.$state = $state;
  }

  $onInit() {
    this.obtenerConexion();
   
    if (this.proyecto.cod_documentacion_exp) {
      this.tieneDocumentacion = true;
    }
    this.$log.log('LISTAPROYECTOS====>',this.proyecto);
  }

  cambiarDocumentacion() {
    this.Modal.confirm('¿Está seguro/a de modificar la información registrada de la empresa?', () => {
      this.tieneDocumentacion = false;
    });
  }

  cancelarCambio() {
    this.proyecto.cod_documentacion_exp = this.codigoDocumentacion;
    this.tieneDocumentacion = true;
  }
  procesoDocumentacionEmpresa() {
    this.Modal.confirm(`¿Está seguro/a de modificar el código de formulario, de la propuesta registrada por la empresa?
    <br><br><br><p> Nota: si acepta en la sección de PENDIENTES, de click en el boton editar (imagen lápiz) ahi encontrara su proyecto, para que pueda realizar el cambio del nuevo codigo de formulario generado en el sistema de <strong>Registro de Empresas</strong</p>
    `, () => {
      const dts=this.Integracion.cambioEstadoProyecto('REGISTRO_EMPRESA',this.proyecto.id_proyecto,this.dtsUsuario.id_usuario,this.dtsRol.id_rol)
      dts.then(function successCallback(respuesta){
        return respuesta.data;
       //console.log(respuesta.data);
      })
      .then((dts)=>{ 
        this.$log.log('valor devuelto',dts);
        
        this.$state.go('pendientes');
        //console.log(dts);
      })
    });
  }

  cancelarDocumentacionEmpresa() {
    
  }
  obtenerConexion() {

    this.dtsRol = JSON.parse(localStorage.getItem("upre_rol"));
    this.dtsUsuario = JSON.parse(localStorage.getItem("upre_user"));
    this.habilitacionBotonDocumentacionEmpresa();
  }
  habilitacionBotonDocumentacionEmpresa(){
    if ((this.proyecto.estado_proyecto=='REGISTRO_GARANTIAS_CIFE' || 
    this.proyecto.estado_proyecto=='REGISTRO_GARANTIAS_MAE' || 
    this.proyecto.estado_proyecto=='REGISTRO_GARANTIAS' || 
    this.proyecto.estado_proyecto=='APROBACION_TECNICO_CIF_MAE' || 
    this.proyecto.estado_proyecto=='APROBACION_TECNICO') && this.dtsRol.nombre=='EMPRESA'){
      this.estadoBoton=true;
      this.$log.log('estado boton',this.estadoBoton);
    }
    else{
      this.estadoBoton=false;
      this.$log.log('estado boton',this.estadoBoton);
    }
    
  }

}

export default CodigoContratoController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/codigo-contrato/codigo-contrato.controller.js